'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = undefined;

var _schemas = require('./schemas');

var _eventPool = require('./eventPool');

var eventPoolInterface = _interopRequireWildcard(_eventPool);

var _event = require('./event');

var eventInterface = _interopRequireWildcard(_event);

var _dictionary = require('./dictionary');

var dictionaryInterface = _interopRequireWildcard(_dictionary);

var _identifiers = require('./identifiers');

var identifiersInterface = _interopRequireWildcard(_identifiers);

var _metaProperties = require('./metaProperties');

var metaPropertiesInterface = _interopRequireWildcard(_metaProperties);

var _tracker = require('./tracker');

var trackerInterface = _interopRequireWildcard(_tracker);

var _storageKeys = require('./storageKeys');

var storageKeys = _interopRequireWildcard(_storageKeys);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var createClient = exports.createClient = function createClient() {
  var dependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  /*
   * Step 1: Normalize & validate client dependencies
   */
  var parsedDependencies = _schemas.clientDependenciesSchema.normalize(dependencies);
  _schemas.clientDependenciesSchema.validate(parsedDependencies, '"createClient"', function (err) {
    /* Rethrow to break execution thread */
    throw err;
  });

  /*
   * Step 2: Build the client with those dependencies
   */
  var clientName = parsedDependencies.clientName,
      getDebug = parsedDependencies.getDebug,
      getEmail = parsedDependencies.getEmail,
      getHubId = parsedDependencies.getHubId,
      getHstc = parsedDependencies.getHstc,
      getLang = parsedDependencies.getLang,
      getTempStorage = parsedDependencies.getTempStorage,
      logMessage = parsedDependencies.logMessage,
      logError = parsedDependencies.logError,
      reportError = parsedDependencies.reportError,
      send = parsedDependencies.send,
      setTempStorage = parsedDependencies.setTempStorage;

  var eventPool = eventPoolInterface.createEventPool({
    getTempStorage: getTempStorage,
    setTempStorage: setTempStorage
  });
  var sendToNetwork = function sendToNetwork(_ref, events) {
    var identifiers = _ref.identifiers,
        _ref$isBeforeUnload = _ref.isBeforeUnload,
        isBeforeUnload = _ref$isBeforeUnload === undefined ? false : _ref$isBeforeUnload,
        _ref$isExternalHost = _ref.isExternalHost,
        isExternalHost = _ref$isExternalHost === undefined ? false : _ref$isExternalHost;

    var isAuthed = !!(identifiers.raw.email && identifiers.raw.hubId);
    var query = 'clientSendTimestamp=' + Date.now();
    if (isExternalHost) {
      query = query + '&dil=true';
    }
    send({
      events: events,
      isBeforeUnload: isBeforeUnload,
      isAuthed: isAuthed,
      query: query
    });
  };
  var flushPoolAndSendToNetwork = function flushPoolAndSendToNetwork(_ref2) {
    var identifiers = _ref2.identifiers;

    var events = eventPool.flush();
    if (events && events.length) {
      sendToNetwork({ identifiers: identifiers }, events);
    }
  };
  var sendToPool = function sendToPool(_ref3, event) {
    var identifiers = _ref3.identifiers;

    if (!eventPool.getIsInitialized()) {
      eventPool.initialize({
        normalizeEvent: function normalizeEvent() {
          for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
            rest[_key] = arguments[_key];
          }

          return eventInterface.normalizeIdentifiers.apply(eventInterface, [identifiers].concat(rest));
        }
      });
    }
    eventPool.push(event);
    eventPoolInterface.scheduleFlush(function () {
      return flushPoolAndSendToNetwork({ identifiers: identifiers });
    });
  };
  var getShouldStoreEventKeys = function getShouldStoreEventKeys() {
    return getTempStorage(storageKeys.shouldStoreEventKeys) === 'true';
  };
  var recordTrackedEvent = function recordTrackedEvent(event) {
    try {
      var recordedEvents = JSON.parse(getTempStorage(storageKeys.recordedEventKeys) || JSON.stringify([]));
      recordedEvents.push(JSON.parse(event.what_extra_json).eventKey);
      setTempStorage(storageKeys.recordedEventKeys, JSON.stringify(recordedEvents));
    } catch (err) {
      /* NOOP */
    }
  };
  var sendToClient = function sendToClient(_ref4) {
    var bypassPool = _ref4.bypassPool,
        isBeforeUnload = _ref4.isBeforeUnload,
        isExternalHost = _ref4.isExternalHost,
        recordTrackedEventKeys = _ref4.recordTrackedEventKeys;
    var identifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var shouldPool = !bypassPool && !isBeforeUnload;
    if (shouldPool) {
      sendToPool({
        identifiers: identifiers
      }, event);
    } else {
      sendToNetwork({
        identifiers: identifiers,
        isBeforeUnload: isBeforeUnload,
        isExternalHost: isExternalHost
      }, [event]);
    }
    if (recordTrackedEventKeys) {
      recordTrackedEvent(event);
    }
  };
  var getMetaProperties = function getMetaProperties() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return metaPropertiesInterface.getMetaProperties.apply(metaPropertiesInterface, [{
      clientName: clientName,
      getTempStorage: getTempStorage,
      setTempStorage: setTempStorage
    }].concat(args));
  };

  return {
    createTracker: function createTracker() {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return trackerInterface.createLockedTracker.apply(trackerInterface, [{
        createIdentifiers: identifiersInterface.createIdentifiers,
        createEventPayload: eventInterface.createEventPayload,
        createDictionary: dictionaryInterface.createDictionary,
        dictionaryLookup: dictionaryInterface.dictionaryLookup,
        getMetaProperties: getMetaProperties,
        getShouldStoreEventKeys: getShouldStoreEventKeys,
        getDebug: getDebug,
        getEmail: getEmail,
        getHubId: getHubId,
        getHstc: getHstc,
        getLang: getLang,
        logError: logError,
        logMessage: logMessage,
        reportError: reportError,
        sendToClient: sendToClient
      }].concat(args));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.319/js/index.js
// module id = 620
// module chunks = 177